// DEV
export const apiDomain = "https://sut-api.ksta.co/";
// export const apiDomain = "http://localhost:8000/";
